import { WorkCell } from "../../../model";
import { CustomTableColumn } from "./custom-table-column";

export class LocationSchemaThingGroupActionTableColumn extends CustomTableColumn {

    workCells: WorkCell[];

    constructor(name: string, label: string, workCells: WorkCell[]) {
        super(name, label, null);
        this.workCells = workCells || [];
    }

}
